import source from "@/messages/quiz-results-source.json";
import mandarinQuizResultsDraft from "@/messages/mandarin-quiz-results.json";
import type { Locale } from "./locales";
import { formatQuizRunner } from "./quiz-runner-copy";

export function quizResultsCopy(locale: Locale = "en"): typeof source {
  return structuredClone(locale === "en" ? source : mandarinQuizResultsDraft);
}
export function buildQuizShareText(
  title: string,
  score: number,
  total: number,
  locale: Locale = "en"
): string {
  const pct = Math.round((score / total) * 100);
  const emoji = pct === 100 ? "💯" : pct >= 80 ? "🔥" : pct >= 60 ? "👍" : "💪";
  return formatQuizRunner(quizResultsCopy(locale).shareText, {
    emoji,
    score,
    total,
    title,
  });
}
export function buildQuizWhatsAppMessage(
  title: string,
  score: number,
  total: number,
  missedTopics?: string[],
  locale: Locale = "en"
): string {
  const copy = quizResultsCopy(locale);
  const pct = Math.round((score / total) * 100);
  let message = formatQuizRunner(copy.opening, { title, score, total, pct });
  if (missedTopics && missedTopics.length > 0) {
    message += formatQuizRunner(copy.missed, {
      topics: missedTopics.slice(0, 3).join(", "),
    });
  } else {
    message += pct < 80 ? copy.plan : copy.next;
  }
  return message;
}
